import { Link, createFileRoute } from '@tanstack/react-router'
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Separator } from "@/components/ui/separator"
import { useForm } from "react-hook-form"
import {
    Form,
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
  } from "@/components/ui/form"
import { useMutation, useQuery } from "@tanstack/react-query"
import {  showPhoneBook, updatePhoneBook } from "@/queries/phonebook"
import { toast } from "sonner"
import { useMemo, useState } from "react"
import z from "zod"
import { zodResolver } from '@hookform/resolvers/zod'

export const Route = createFileRoute('/phone-book/$id/')({
  component: UpdatePhoneBook,
})

function UpdatePhoneBook() {
  const navigate = Route.useNavigate()
  const { id } = Route.useParams()
  const [defaultPhoneBook, setDefaultPhoneBook] = useState<z.infer<typeof updateSchema> | null>(null)

  const updateSchema = z.object({
    phone_number: z.string({required_error:'وارد کردن شماره تلفن الزامی است' }),
    name: z.string({required_error: 'وارد کردن نام الزامی می باشد'}).min(3, 'نام کاربر نمی تواند کمتر از ۳ حرف باشد')
  })

  const getPhoneBook = useQuery({
    queryFn: () => showPhoneBook(id),
    queryKey: ['showPhoneBook'],
  })

  const form = useForm<z.infer<typeof updateSchema>>({
    resolver: zodResolver(updateSchema),
    defaultValues: useMemo(() => {
      if (!defaultPhoneBook) {
        return { phone_number: '' }
      } else {
        return defaultPhoneBook
      }
    }, [defaultPhoneBook]),
    values: {
      phone_number: getPhoneBook.data?.data?.data?.phone_number?.replace('98', '0'),
      name: getPhoneBook.data?.data?.data?.name,
    }
  })

  const updatePhoneBookMutation = useMutation({
    mutationFn: (data: z.infer<typeof updateSchema>) => updatePhoneBook(id, data),
    mutationKey: ['update', 'phoneBook'],
    onSuccess() {
      // console.log('phone book created!')
      toast.success('مخاطب با موفقیت ویرایش شد')
      navigate({to: '/phone-book'})
    },
    onError() {
      // console.log('phone book error !')
      toast.error('خطایی در ویرایش مخاطب رخ داده است')
    }
  })

  const onSubmit = (values: z.infer<typeof updateSchema>) => {
    updatePhoneBookMutation.mutate(values)
  }

  return <>
    <Card>
      <CardHeader className="flex flex-row justify-between items-center">
        <CardTitle>
          ویرایش مخاطب
        </CardTitle>
        <Link to="/phone-book">
          <Button variant="outline">
            بازگشت
          </Button>
        </Link>
      </CardHeader>
      <Separator className="my-2" />
      <CardContent>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <FormField control={form.control} name="phone_number" render={({ field }) => <FormItem>
              <FormLabel>شماره تلفن</FormLabel>
              <FormControl>
                <Input {...field} maxLength={12} type="tel" phone />
              </FormControl>
              <FormMessage />
            </FormItem>} />

            <FormField control={form.control} name="name" render={({ field }) => <FormItem className="my-2">
              <FormLabel>
                نام مخاطب
              </FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

            <Button className="mt-4" isLoading={updatePhoneBookMutation.isPending}>ویرایش</Button>
          </form>
        </Form>
      </CardContent>
    </Card>
  </>
}